module.exports = __webpack_public_path__ + "static/media/CB_blue.eb32b8ee.svg";